import { useState } from "react";
import { Select, SelectItem, SlotsToClasses, SelectSlots } from "@nextui-org/react";
import { ChevronUp } from "lucide-react";
import { VendorRiskLevel } from "./OverviewCards.types";
import RiskLevelChip from "./RiskLevelChip";

interface RiskDropdownProps {
  riskLevel: VendorRiskLevel;
  onRiskLevelChange: (newValue: VendorRiskLevel) => void;
  isDisabled: boolean;
  className?: string;
}

const RiskDropdown = ({
  riskLevel,
  onRiskLevelChange,
  isDisabled,
  className
}: RiskDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Select
      aria-label="Risk Level"
      placeholder="Select Risk Level"
      selectedKeys={new Set([riskLevel])}
      onChange={(e) => onRiskLevelChange(e.target.value as VendorRiskLevel)}
      onOpenChange={setIsOpen}
      selectionMode="single"
      className={className}
      classNames={riskSelectFieldClassNames}
      renderValue={() => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <RiskLevelChip riskLevel={riskLevel} showIcon={false} showEditIcon={false} />
          <ChevronUp
            style={{
              width: '12px',
              height: '12px',
              color: '#64748B',
              transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
              transition: 'transform 0.2s ease'
            }}
          />
        </div>
      )}
      isDisabled={isDisabled}
    >
      <SelectItem
        key="High"
        value="High"
        textValue="High Risk"
        classNames={selectItemClassNames}
      >
        <RiskLevelChip riskLevel="High" showIcon={false} showEditIcon={false} />
      </SelectItem>
      <SelectItem
        key="Medium"
        value="Medium"
        textValue="Medium Risk"
        classNames={selectItemClassNames}
      >
        <RiskLevelChip riskLevel="Medium" showIcon={false} showEditIcon={false} />
      </SelectItem>
      <SelectItem
        key="Low"
        value="Low"
        textValue="Low Risk"
        classNames={selectItemClassNames}
      >
        <RiskLevelChip riskLevel="Low" showIcon={false} showEditIcon={false} />
      </SelectItem>
    </Select>
  );
};

const selectItemClassNames = {
  base: "p-2 gap-2 h-9 rounded-[4px] self-stretch data-[hover=true]:bg-[#E6F1FE] data-[selectable=true]:focus:bg-[#E6F1FE] data-[focus=true]:bg-[#E6F1FE]",
  selectedIcon: "hidden",
  title: "flex-none",
};

const riskSelectFieldClassNames: SlotsToClasses<SelectSlots> = {
  base: "bg-transparent w-fit min-w-fit",
  mainWrapper: "bg-transparent w-fit",
  innerWrapper: "bg-transparent h-5 min-h-5 w-fit hover:bg-transparent data-[hover=true]:bg-transparent",
  selectorIcon: "hidden",
  trigger: "bg-transparent shadow-none p-0 h-5 min-h-5 w-fit hover:bg-transparent data-[hover=true]:bg-transparent",
  popoverContent: "bg-white border border-[#E2E8F0] rounded-[6px] p-1 w-[122px] shadow-[0px_0px_15px_rgba(0,0,0,0.03),0px_2px_30px_rgba(0,0,0,0.08),0px_0px_1px_rgba(0,0,0,0.3)]",
  listbox: "p-0 gap-0",
  listboxWrapper: "p-0",
};

export default RiskDropdown;
